import Vue from "vue"
import SearchWidget from './components/SearchWidget.vue'
import store from './store/index'
import VueCompositionApi from "@vue/composition-api";

Vue.use(VueCompositionApi);
Vue.config.productionTip = false;

let elements = document.querySelectorAll('widget-search');

if (elements.length) {
    elements.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                let searchEndpoint = this.$el.attributes.getNamedItem('search-endpoint');
                let searchIndex = this.$el.attributes.getNamedItem('search-index');
                let searchOrder = this.$el.attributes.getNamedItem('search-order');
                let showCategories = this.$el.attributes.getNamedItem('show-categories');
                let disableFiltering = this.$el.attributes.getNamedItem('disable-filtering');
                let labels = this.$el.attributes.getNamedItem('labels');
                let fixedFilters = this.$el.attributes.getNamedItem('fixed-filters');
                let userFilters = this.$el.attributes.getNamedItem('user-filters');
                let userFilterOverride = this.$el.attributes.getNamedItem('user-filter-override');
                let scopeFilter = this.$el.attributes.getNamedItem('scopes');
                let scopeLinks = this.$el.attributes.getNamedItem('scope-links');
                let searchQuery = this.$el.attributes.getNamedItem('search-query');
                let imageFallback = this.$el.attributes.getNamedItem('image-fallback');
                let shouldDelaySearch = this.$el.attributes.getNamedItem('should-delay-search');

                return h(SearchWidget, {
                    props: {
                        searchSettings: {
                            endpoint: searchEndpoint?.value ?? null,
                            index: searchIndex?.value ?? null,
                            order: searchOrder?.value ?? null,
                            showCategories: showCategories?.value ?? null,
                            disableFiltering: disableFiltering ? !!disableFiltering.value : false,
                            labels: labels ? JSON.parse(labels.value) : null,
                            shouldDelaySearch: shouldDelaySearch ? !!shouldDelaySearch.value : false,
                        },
                        fixedFilters: fixedFilters ? JSON.parse(fixedFilters.value) : null,
                        userFilters: userFilters ? JSON.parse(userFilters.value) : null,
                        userFilterOverride: userFilterOverride ? JSON.parse(userFilterOverride.value) : null,
                        scopeFilter: scopeFilter ? JSON.parse(scopeFilter.value) : null,
                        scopeLinks: scopeLinks ? JSON.parse(scopeLinks.value) : null,
                        query: searchQuery?.value ?? null,
                        imageFallback: imageFallback?.value ?? "vulogo"
                    }
                })
            },
        });
    });
}
